import $ from "jquery";
import GLightbox from "glightbox";
import initializeTooltip from "./utils/tooltips";
import { initializeSelect2 } from "./utils/select2Helpers";

function initGLightbox(target) {
  const fragmentSelector = `[data-fragment-id="${target.dataset.fragmentId}"]`;

  // Get all unique gallery IDs within this fragment
  const glightboxElements = target.querySelectorAll(".glightbox[data-gallery]");
  const galleryIds = [
    ...new Set([...glightboxElements].map((el) => el.dataset.gallery)),
  ];

  // Initialize a separate GLightbox instance for each gallery group
  galleryIds.forEach((galleryId) => {
    GLightbox({
      selector: `${fragmentSelector} .glightbox[data-gallery="${galleryId}"]`,
      width: "90vw",
      height: "90vh",
    });
  });

  // Also handle any glightbox elements without data-gallery (fallback)
  const ungroupedElements = target.querySelectorAll(
    ".glightbox:not([data-gallery])",
  );
  if (ungroupedElements.length > 0) {
    GLightbox({
      selector: `${fragmentSelector} .glightbox:not([data-gallery])`,
      width: "90vw",
      height: "90vh",
    });
  }
}

export default function initWidgets(target) {
  if (!("fragmentId" in target.dataset)) {
    target.dataset.fragmentId = crypto.randomUUID();
  }

  initGLightbox(target);

  $("select.select2", target).each(function (index, el) {
    initializeSelect2(el);
  });

  target.querySelectorAll("[data-toggle=tooltip]").forEach(function (el) {
    initializeTooltip(el);
  });

  var calendarEl = target.querySelector("[data-calendar]");
  if (calendarEl) {
    import("./calendar.js").then(function ({ initCalendar }) {
      initCalendar(calendarEl);
    });
  }
}
